// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1wX73","large":"styles_large__1GZoT"};